import type {SupportedReferenceType} from '../components/ReferencesSelectPanel'
import {isRepository} from '../utils/copilot-chat-helpers'
import {useChatState} from '../utils/CopilotChatContext'
import {useSelectedCopilotSpaceId} from './use-selected-custom-copilot-id'

export type SupportedAttachmentType = 'repositories' | 'references' | 'knowledge-bases' | 'upload' | 'agents'

/**
 * Returns the supported attachment types and reference types based on the current state of the chat.
 * Reference types are specifically used in the ReferencesSelectPanel component.
 */
export function useSupportedAttachmentTypes(): {
  supportedAttachmentTypes: SupportedAttachmentType[]
  supportedReferenceTypes: SupportedReferenceType[]
} {
  const state = useChatState()
  const isCopilotSpaceAttachments = useSelectedCopilotSpaceId() !== null

  const supportedAttachmentTypes: SupportedAttachmentType[] = ['upload']

  const referencesEnabled = true

  const shouldShowKnowledge =
    state.renderKnowledgeBases && ((state.currentTopic && isRepository(state.currentTopic)) || !state.currentTopic)

  if (!isCopilotSpaceAttachments) {
    supportedAttachmentTypes.push('repositories')
  }

  if (referencesEnabled) {
    supportedAttachmentTypes.push('references')
  }

  if (shouldShowKnowledge && !isCopilotSpaceAttachments) {
    supportedAttachmentTypes.push('knowledge-bases')
  }

  if (!isCopilotSpaceAttachments) {
    supportedAttachmentTypes.push('agents')
  }
  const supportedReferenceTypes: SupportedReferenceType[] = isCopilotSpaceAttachments
    ? ['files']
    : ['files', 'folders', 'symbols']
  return {supportedAttachmentTypes, supportedReferenceTypes}
}
